import type { FC, ReactElement } from 'react';
import { useEffect } from 'react';

import { useMessagesFeedStore } from './useMessagesFeedStore';

export const MessagesRequester: FC<{ children: ReactElement }> = ({
  children,
}) => {
  const fetch = useMessagesFeedStore((state) => state.fetch);
  useEffect(() => {
    fetch();
  }, [fetch]);

  return children;
};
